import { __assign, __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import Menu from '../Menu';
import Popover from '../../Popover/PopperPopover/PopperPopover';
import s from './PopoverMenu.scss';
/** @deprecated */
var PopoverMenu = /** @class */ (function (_super) {
    __extends(PopoverMenu, _super);
    function PopoverMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopoverMenu.prototype.render = function () {
        return (React.createElement(Popover, __assign({}, this.props, { contentClassName: classnames(s['root'], 'no-theme-skin', this.props.contentClassName) }),
            React.createElement(Menu, { onSelect: this.props.onSelect }, this.props.children)));
    };
    PopoverMenu.defaultProps = {
        items: [],
        isOpen: true,
        noPadding: true,
    };
    return PopoverMenu;
}(React.Component));
export default PopoverMenu;
//# sourceMappingURL=PopoverMenu.js.map